import React from 'react'
import ReactModal from 'react-modal'

const ConfirmationModal = (props) => {
  return (
    <ReactModal isOpen={true} shouldCloseOnEsc={false}>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='games-confirm-header' />
        </div>
        <div className='col-sm-12'>
          <h2>Are you sure?</h2>
        </div>
        <div className='col-sm-12'>
          <p>Do you really want to confirm these events?<br />This process cannot be undone</p>
        </div>
        <div className='col-sm-12'>
          <button className='btn btn-secondary games-select-button' onClick={props.onConfirm}>Yes</button>
          <button className='btn btn-secondary games-select-button' onClick={props.onCancel}>No</button>
        </div>
      </div>
    </ReactModal>
  )
}

export default ConfirmationModal
